<template>
  <div class="text-center">
    <!-- <v-btn
      :disabled="saving"
      :loading="saving"
      class="white--text"
      color="purple darken-2"
      @click="saving = true"
    >
      Start loading
    </v-btn> -->
    <v-dialog
      v-model="saving"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{$t('common.pleaseStandBy')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    // data () {
    //   return {
    //     dialog: false,
    //   }
    // },
    computed: {
      ...mapState('app',['locale', 'saving']),
    },
    // watch: {
    //   dialog (val) {
    //     if (!val) return

    //     setTimeout(() => (this.dialog = false), 4000)
    //   },
    // },
  }
</script>